import { getPermissionsForCoreUploadTypes } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'
import { OPERATIONS_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/operations')({
  staticData: {
    title: 'route.coreUploadData.operations',
    crumb: 'route.coreUploadData.operations',
    permissions: getPermissionsForCoreUploadTypes(OPERATIONS_UPLOAD_TYPES),
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route, { atLeastOne: true })
  },
})
